import {useClient} from '@adamlip/okeoke.client';
import IconComponent from 'components/IconComponent';
import LanguageSelector from './LanguageSelector';
import BasketWithBadge from './BasketWithBadge';
import BasketValue from './BasketValue';
import {useNavigate} from 'react-router-dom';
import OrderItemModalV3 from 'components/Modals/OrderItemModalV3';
import {useState} from 'react';

export default function Element({data, isGrid, oneRow}) {
  const {languageCode} = useClient();
  const navigate = useNavigate();

  const [itemModalOpen, setItemModalOpen] = useState(false);

  //console.log(data);

  let hasIcon = data?.iconCode != null;

  const handleClick = () => {
    if (data?.action === 'selectCategory' && data?.actionParam != null && data?.actionParam.length > 0) {
      navigate(`/order?categoryUUID=${data?.actionParam}`);
    }
    if (data?.action === 'selectItem' && data?.actionParam != null && data?.actionParam?.length > 0) {
      setItemModalOpen(true);
    }
    if (data?.action === 'navigate' && data?.actionParam != null && data?.actionParam?.length > 0) {
      navigate(`/${data?.actionParam}`);
    }
  };

  if (data?.actionParam === 'languageSelector') return <LanguageSelector isGrid={isGrid} />;

  if (data?.actionParam === 'basketWithBadge') return <BasketWithBadge icon={data?.iconCode} isGrid={isGrid} />;

  if (data?.actionParam === 'basketValue') return <BasketValue isGrid={isGrid} />;

  return (
    <>
      <div
        className={`flex shrink-0 max-w-[93%] ${isGrid ? 'flex-col items-center' : 'flex-row w-full btn primary m-0 mx-auto'} ${
          oneRow ? 'h-14' : ''
        } rounded-[var(--general-border-radius) ${hasIcon ? '' : 'p-2 justify-center bg-primary/20 text-primary rounded-[var(--general-border-radius)]'}`}
        style={{
          border: `var(--startNav-border-width) solid var(--startNav-border-color)`,
        }}
        onClick={() => handleClick()}>
        {hasIcon && (
          <div className={`${isGrid ? 'w-14 h-14 p-2 rounded-[var(--general-border-radius)] bg-primary/20' : 'mr-2 w-6 h-6'}`}>
            <IconComponent iconCode={data?.iconCode} className={isGrid ? 'primary' : ''} />
          </div>
        )}
        <div className={`text-center ${hasIcon ? 'text-sm' : 'text-lg'} ${isGrid ? 'text-primary' : 'text-[var(--button-text-color)]'}`}>
          {data?.label?.[languageCode] || data?.label?.hu || ''}
        </div>
      </div>
      {data?.action === 'selectItem' && <OrderItemModalV3 isOpen={itemModalOpen} setIsOpen={setItemModalOpen} itemUUID={data?.actionParam} />}
    </>
  );
}
